import { Link } from "@tanstack/react-router";
import { SectionMark } from "@/components/section-mark";
import { cta } from "@/lib/analytics";

export function ClosingSection() {
  return (
    <section aria-labelledby="domkniecie-heading" className="content-visibility-auto border-b border-ink/10">
      <div className="container-page section-pad">
        <div className="grid gap-8 md:grid-cols-[0.42fr_1fr] md:gap-12">
          <div>
            <SectionMark number="13" label="Dobry moment" />
          </div>
          <div className="max-w-2xl">
            <h2 id="domkniecie-heading" className="display-xl text-[1.9rem] md:text-[2.4rem]">
              Nie musisz mieć{" "}
              <span className="serif-display italic text-coral-text">kryzysu</span>, żeby
              zacząć pracować nad sobą.
            </h2>
            <div className="mt-8 h-px w-full bg-steel" />
            <p className="lead-serif measure-text mt-8 max-w-xl">
              Poznaj formę współpracy, która odpowiada Twojej sytuacji.
            </p>
            <div className="mt-8 grid gap-3 sm:grid-cols-3">
              <Link
                to="/kontakt"
                {...cta("wystapienia-domkniecie", "domkniecie", "prelekcja")}
                className="btn-base btn-primary inline-flex min-h-11 items-center justify-center"
              >
                Zaproś mnie na wydarzenie
              </Link>
              <Link
                to="/mastermind"
                {...cta("mastermind-domkniecie", "domkniecie", "mastermind")}
                className="btn-base btn-outline inline-flex min-h-11 items-center justify-center"
              >
                Poznaj mastermind
              </Link>
              <Link
                to="/konsultacje"
                {...cta("konsultacje-domkniecie", "domkniecie", "konsultacja")}
                className="btn-base btn-outline inline-flex min-h-11 items-center justify-center"
              >
                Poznaj konsultacje
              </Link>
            </div>
            <p className="cta-note">
              Pełna dyskrecja. Wszystko, o czym rozmawiamy, zostaje między nami.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
